(function($) {
  $(function() {
    var $schoolBlock = $('.school-list .school-block a.stage');

    $schoolBlock.on('click.schoolBlock', function(e) {
      if (!$(this).hasClass(actClass)) {
        $schoolBlock.removeClass(actClass).find('.details .desc').slideUp('400');
        e.preventDefault();
        $(this).addClass(actClass).find('.details .desc').slideDown('400');
      }
    });
  });
})($JQ);
